import ModalTemplate from "components/modal/modal-template";
import Typography from "components/typography";
import React from "react";

interface IProps {
  close: () => void;
  restart: () => void;
}
const RestartResyncModal = ({ close, restart }: IProps) => {
  return (
    <ModalTemplate
      close={close}
      confirm={restart}
      confirmText="Restart Sync"
      cancelText="Cancel"
      header="Restart Sync?"
      twoButtons
    >
      <Typography size="lg" align="center" weight="medium" mx="8">
        Your current sync will be deleted
      </Typography>
    </ModalTemplate>
  );
};

export default RestartResyncModal;
